import React from 'react'

function TrackTasks(props) {
  let { dashData } = props
  return (
    <div className='container py-4'>
      <table className="table table-striped table-vcenter">
        <thead>
          <tr>
            <th style={{ width: "50px" }}>#</th>
            <th>Task Title</th>
          </tr>
        </thead>
        <tbody>
          {dashData[0]?.Boards?.map((item) => {
            if (item.title === "DONE" || item.title === "done" || item.title === "Done" || item.title === "DoNE" || item.title === "DONe" || item.title === "dONE" || item.title === "dOne" || item.title === "doNE" || item.title === "donE") {
              return (
                item.cards.map((item, index) => {
                  return (
                    <tr key={item.id}>
                      <td style={{ color: "white" }}>{index + 1}</td>
                      <td style={{ color: "white" }}>{item.title}</td>
                    </tr>
                  )
                }))
            }
          })}
        </tbody>
      </table>
    </div>
  )
}

export default TrackTasks